export default __webpack_public_path__ + "b7aa619eccf4e377b1212ffd2ae98029.png";